import React, { Component } from 'react';
import { connect } from 'react-redux';
import { goto } from '../../../../actions/historyActions';
import { isApp, resolveLocalizedText } from '../../../../utils';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import { getCustomerProfileResetUsenameOrPasswordConfirmConfig } from '../../selectors/customerProfileResetUNOrPWConfirmSelectors';
import {
  getCustomerProfileUsenameCurTab,
  getCustomerProfileUsenameEmail,
  getCustomerProfileUsenameMobile,
} from '../../selectors/customerProfileResetUsenameSelectors';
import {
  RESET_USER_NAME_EMAIL_TYPE,
  RESET_USER_NAME_MOBILE_TYPE,
} from '../../constants/constants';
import {
  getReloginDialogDeepLink,
  getCheckForceLogoutDeepLink,
  getForceLogoutFlagDeepLink,
} from '../../selectors/customerProfileSelectors';
import {
  signOut,
  checkForceLogout,
  updateForceLogoutFlag,
  showReloginPopup,
} from '../../../../actions/authActions';
import { LocalizedText } from '../../../../types/LocalizedTextTypes';
import { getCustomerProfileModalConfig } from '../../selectors/customerProfileSelectors';
import browserHistory from '../../../../stores/browserHistory';
import { ChangeContactView } from '../../components/ChangeContactView';
import './style.scss';
import {
  trackUpdateContactSuccess,
  TrackUpdateContactSuccessAction,
  TrackUpdateContactSuccessContent,
} from '../../../../utils/generalGaEventAnalytics';

export interface CustomerResetUserNameConfirmProps {
  userNameTitle: string;
  userNameSuccess: string;
  userNameDesc: string;
  buttonText: string;
  curUserNameTab: string;
  email: string;
  mobile: string;
  onSignOut: () => void;
  onCheckForceLogout: () => void;
  onUpdateForceLogout: () => void;
  onShowReloginPopup: () => void;
  reloginDialogDeepLink: string;
  checkForceLogoutDeepLink: string;
  forceLogoutFlagDeepLink: string;
  profileModalConfig: { [prop: string]: LocalizedText };
  stepContext: any;
}

export interface CustomerResetUserNameConfirmState {}
export class CustomerResetUserNameConfirm extends Component<
  CustomerResetUserNameConfirmProps,
  CustomerResetUserNameConfirmState
> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { curUserNameTab } = this.props;
    !curUserNameTab && goto('emma-customer-profile-resetusenameorpassword');
    trackUpdateContactSuccess(
      TrackUpdateContactSuccessContent.USERNAME,
      TrackUpdateContactSuccessAction.UPDATE,
    );
  }

  componentWillUnmount() {
    const { onShowReloginPopup, reloginDialogDeepLink } = this.props;

    if (!isApp()) {
      onShowReloginPopup();
    } else {
      EmmaFactory.createInstance().then((e) => {
        e.instance.goTo(reloginDialogDeepLink);
      });
    }
  }

  handleOK = () => {
    const { reloginDialogDeepLink, onShowReloginPopup } = this.props;

    if (isApp()) {
      EmmaFactory.createInstance().then((e) => {
        e.instance.goTo(reloginDialogDeepLink);
      });
    } else {
      onShowReloginPopup();
    }
  };

  handleRelogin = () => {
    const { onSignOut } = this.props;

    onSignOut();
  };

  getChangedUserName() {
    const { email, mobile, curUserNameTab } = this.props;
    if (curUserNameTab === RESET_USER_NAME_EMAIL_TYPE) {
      return email;
    } else if (curUserNameTab === RESET_USER_NAME_MOBILE_TYPE) {
      // return `${(mobile && mobile.length - 4 > 0 &&  mobile.substring(0, mobile.length - 4)) || ''}****`
      return mobile;
    }
  }

  onGoBack = () => {
    browserHistory.goBack();
  };

  render() {
    const {
      userNameTitle,
      userNameSuccess,
      userNameDesc,
      buttonText,
      stepContext,
    } = this.props;
    const userName = this.getChangedUserName();
    return (
      <div className="customer-reset-confirm">
        <ChangeContactView
          onGoBack={this.onGoBack}
          pageName={userNameTitle ? resolveLocalizedText(userNameTitle) : ''}
          stepContext={stepContext}
          activeIndex={3}
        >
          <div className="customer-reset-confirm-container emma-stylesheet-grid-system">
            <div className="customer-reset-confirm-container-text">
              {userNameSuccess}
            </div>
            <div>{userNameDesc}</div>
            <div className="customer-reset-confirm-container-value">
              {userName}
            </div>
            <div className="customer-reset-confirm-container-button">
              <button
                className="emma-stylesheet-primary-default-button"
                data-enable-ga
                data-ga-type="button"
                onClick={() => this.handleOK()}
              >
                {buttonText}
              </button>
            </div>
          </div>
        </ChangeContactView>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const labelConfig =
      getCustomerProfileResetUsenameOrPasswordConfirmConfig(state);
    const reloginDialogDeepLink =
      getReloginDialogDeepLink(state) || 'emma-customer-profile/relogin-dialog';
    const curUserNameTab = getCustomerProfileUsenameCurTab(state);
    const profileModalConfig = getCustomerProfileModalConfig(state);
    const checkForceLogoutDeepLink =
      getCheckForceLogoutDeepLink(state) ||
      'emma-customer-profile/check-force-logout';
    const forceLogoutFlagDeepLink =
      getForceLogoutFlagDeepLink(state) ||
      'emma-customer-profile/update-force-logout-flag?isForceLogout=true';

    return {
      userNameTitle: labelConfig.userNameTitle
        ? resolveLocalizedText(labelConfig.userNameTitle)
        : '',
      userNameSuccess: labelConfig.userNameSuccess
        ? resolveLocalizedText(labelConfig.userNameSuccess)
        : '',
      userNameDesc: labelConfig.userNameDesc
        ? resolveLocalizedText(labelConfig.userNameDesc)
        : '',
      buttonText: labelConfig.buttonText
        ? resolveLocalizedText(labelConfig.buttonText)
        : '',
      email: getCustomerProfileUsenameEmail(state),
      mobile: getCustomerProfileUsenameMobile(state),
      reloginDialogDeepLink,
      curUserNameTab,
      profileModalConfig,
      checkForceLogoutDeepLink,
      forceLogoutFlagDeepLink,
      stepContext: labelConfig.stepContext
        ? resolveLocalizedText(labelConfig.stepContext)
        : '',
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      onSignOut: () => dispatch(signOut()),
      onCheckForceLogout: () => dispatch(checkForceLogout()),
      onUpdateForceLogout: () => dispatch(updateForceLogoutFlag(true)),
      onShowReloginPopup: () => dispatch(showReloginPopup()),
    };
  }
}

export default connect(
  CustomerResetUserNameConfirm.mapStateToProps,
  CustomerResetUserNameConfirm.mapDispatchToProps,
)(CustomerResetUserNameConfirm);
